import { gfs } from '@/utils/functional'
import { keys, path } from 'ramda'
import { gc, gls, rls, sls } from '@/utils/storage'
import { isInApp } from '@/utils/app-communication'

const DONE_AJAX_INIT = 'DONE_AJAX_INIT'
const SET_SESSION_KEY = 'SET_SESSION_KEY'
const UPDATE_TOKEN = 'UPDATE_TOKEN'
const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
const CLEAR_TOKEN = 'CLEAR_TOKEN'
const CLEAR_USER_INFO = 'CLEAR_USER_INFO'
const CLEAR_SESSION_KEY = 'CLEAR_SESSION_KEY'
const UP_DATA_REQUIRE_MIN_GROUP = 'UP_DATA_REQUIRE_MIN_GROUP'

const state = {
  token: do {
    if (isInApp()) {
      null
    } else {
      gls('token') ?? gc('token')
    }
  },
  info: null,
  ajaxInit: false,
  qrcode: null,
  sessionKey: gls('sessionKey'),
  require_min_group: null
}
export default {
  namespaced: true,
  state,
  mutations: {
    [DONE_AJAX_INIT](state, data = true) {
      state.ajaxInit = data
    },
    [SET_SESSION_KEY](state, data) {
      state.sessionKey = data
      sls('sessionKey', data)
    },
    [UPDATE_TOKEN](state, data) {
      state.token = data
      sls('token', data)
    },
    [CLEAR_TOKEN]() {
      state.token = null
      rls('token')
    },
    [UPDATE_USER_INFO](state, data) {
      state.info = data
      if (data?.token) {
        state.token = data?.token
        sls('token', data?.token)
      }
    },
    [CLEAR_USER_INFO](state, data) {
      state.info = null
    },
    [CLEAR_SESSION_KEY](state, data) {
      state.sessionKey = null
      rls('sessionKey')
    },
    [UP_DATA_REQUIRE_MIN_GROUP](state, data) {
      state.require_min_group = data
    }
  },
  actions: {
    async doenAjaxInit({ commit }, params) {
      commit(DONE_AJAX_INIT, params)
    },
    async setSessionKey({ commit }, params) {
      commit(SET_SESSION_KEY, params)
    },
    async updateToken({ commit }, params) {
      commit(UPDATE_TOKEN, params)
    },
    async updateUserInfo({ commit, rootState }, params) {
      commit(UPDATE_USER_INFO, params)
      if (params?.id && !params?.phone) {
        /*用户未绑定手机号*/
        rootState.instance.loginDialog.open()
      }
    },
    async clearToken({ commit, dispatch }, params) {
      commit(CLEAR_TOKEN, params)
      await dispatch('channelAttributionChange', {}, { root: true })
    },
    async clearUserInfo({ commit }, params) {
      commit(CLEAR_USER_INFO, params)
    },
    async clearSessionKey({ commit }, params) {
      commit(CLEAR_SESSION_KEY, params)
    },
    updateRequireMinGroup({ commit }, params) {
      commit(UP_DATA_REQUIRE_MIN_GROUP, params)
    }
  },
  getters: {
    ...gfs(keys(state)),
    auths: path(['info', 'group_rdbc']),
    userType: path(['info', 'group_id']),
    isWhiteUser: (state) => {
      return state.info?.is_sensitive_whitelist ?? false
    },
    isShowSensitivePrice: (state) => {
      if (!state.token) {
        return false
      }
      return !state.info?.is_sensitive_price ?? false
    }
  }
}
